<template>
  <div class="dynamicindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>文档列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/document/create')"
          >创建文档</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="6">
          <el-input
            placeholder="请输入内容"
            v-model="docValue"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dictSearch"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="12">&nbsp;</el-col>
        <el-col :span="3"
          ><el-button
            class="tz-r"
            type="primary"
            round
            plain
            size="middle"
            @click="toClassify"
            >标签列表</el-button
          ></el-col
        >
        <el-col :span="3"
          ><el-button
            class="tz-r"
            type="primary"
            round
            plain
            size="middle"
            @click="tagFn"
            >打标签</el-button
          ></el-col
        >
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable
        v-if="refresh"
        :tableData="docLists"
        :columns="columns"
        :key="timer"
        ref="tableFn"
        @uploadClick="uploadClick"
        @uploadFn="uploadFn"
        :showCheckbox="true"
        @handleTagClose="handleTagClose"
        @multipleSelection="multipleSelectionFn"
      />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <!-- <Edit
      :state="editState"
      @close="editState = false"
      :user="editUnit"
      @confirm="changeTool"
    /> -->
    <!-- 编辑弹框 end -->
    <!-- 批量打标签 -->
    <EditTag
      :key="1 + 'i'"
      :state="tagState"
      @close="tagState = false"
      :tags="tagLists"
      @check="tagCheck"
      @confirm="tagConfirm"
    />
  </div>
</template>

<script>
import {
  docList,
  deleteDoc,
  uploadPhoto,
  deleteTag,
  saveTag,
  classifyList
} from '@/api/document'
import { uploadFile } from '@/api/training'

import TzTable from '@/components/tz-table/Index.vue'
import EditTag from './components/EditTag'
export default {
  components: {
    TzTable,
    EditTag
  },
  data() {
    return {
      timer: '',
      tagState: false,
      tagLists: [], //分类标签集合
      labelCodeList: [], //选择的标签
      refresh: true,
      page: 1, //当前页
      size: '10',
      total: 100,
      docValue: '',
      rowId: '', //当前行id
      editState: false,
      selectIds: [], //批量选择
      editUnit: {},
      docLists: [],
      columns: [
        {
          field: 'docSort',
          title: '排序'
        },
        {
          field: 'remark',
          title: '标准类型'
        },
        {
          field: 'number',
          title: '发布编号'
        },
        {
          title: '中文名字',
          field: 'name'
          // type: 'richText',
          // payload: {
          //   field: 'name'
          // }
        },
        {
          field: 'enName',
          title: '英文名字'
        },
        {
          field: 'pubtime',
          title: '发布时间'
        },
        {
          field: 'usetime',
          title: '实施时间'
        },

        {
          field: 'agency',
          title: '发布机构'
        },

        {
          title: '附件',
          type: 'download',
          payload: {
            field: 'url'
          }
        },
        {
          title: '上传附件',
          type: 'upload'
          // payload: {
          //   field: 'url'
          // }
        },

        {
          title: '标签',
          width: '120',
          type: 'tag',
          payload: {
            field: 'relationList'
          }
        },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                // this.editUnit = JSON.parse(JSON.stringify(row))
                // let edirArr = JSON.parse(JSON.stringify(row))
                // console.log(edirArr)
                this.$router.push({
                  path: '/document/detail',
                  // query: { id: row.uuid, docId: row.docId }
                  query: { id: row.id }
                })
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  created() {
    this.timer = new Date().getTime()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      // this.$forceUpdate()
      this.refresh = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refresh = true
      })
      this.getDocList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.refresh = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refresh = true
      })
      this.getDocList()
    },
    // 列表
    getDocList() {
      let params = {
        value: this.docValue,
        pageSize: Number(this.size),
        pageNum: this.page
      }
      docList(params).then((res) => {
        if (res.code == 200) {
          // 解决页面不刷新
          this.$nextTick(() => {
            let docArr = res.data.records
            this.total = Number(res.data.total)
            this.docLists = docArr
            //   docArr.map((item) => {
            //   return {
            //     name: item.highlight.name
            //       ? item.highlight['name'][0]
            //       : item.source.name,
            //     ...item.source
            //   }
            // })
            console.log(this.docLists, '==================')
          })
        }
      })
    },
    // 分类列表
    toClassify() {
      this.$router.push('/document/classify')
    },
    // 批量选择标准
    multipleSelectionFn(val) {
      console.log(val, '已选择')
      this.selectIds = val
    },
    // 标签删除
    handleTagClose(row) {
      console.log(row, '标签删除')
      this.$confirm(`确认删除分类标签${row.content}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            outIds: row.outId.split(),
            typeIds: row.typeId.split()
          }
          deleteTag(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              setTimeout(() => {
                this.getDocList()
              }, 500)
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 分类列表
    getTagList() {
      let dictparams = {
        type: '1'
      }
      classifyList(dictparams).then((res) => {
        if (res.code == 200) {
          console.log(res)
          if (res.data.length > 0) {
            let dictList = res.data
            dictList.forEach((el) => {
              el['label'] = el.content
              el['value'] = el.id
              el['checked'] = false
              el['type'] = 'info'
            })
            this.tagLists = dictList
          }
        }
      })
      setTimeout(() => {
        this.labelCodeList = []
        this.tagState = true
      }, 300)
    },
    // 标准分类打标签
    tagFn() {
      let ids = this.selectIds.map((el) => {
        return el.id
      })
      if (ids.length == 0) {
        this.$message({
          type: 'error',
          message: '请先选择标准!'
        })
        return
      }
      this.getTagList()
    },

    // 标签选择
    tagCheck(tag, index) {
      console.log(tag, index)
      tag.checked = !tag.checked
      if (tag.checked == true) {
        this.tagLists[index].type = 'danger'
        this.labelCodeList.push(tag.value)
      } else {
        this.tagLists[index].type = 'info'
        this.labelCodeList.splice(this.labelCodeList.indexOf(tag.value), 1)
      }
    },
    // // 标签保存
    tagConfirm() {
      if (this.labelCodeList.length == 0) {
        this.$message({
          message: '请先选择标签',
          type: 'warning'
        })
        return
      }
      let ids = this.selectIds.map((el) => {
        return el.id
      })
      let params = {
        outIds: ids, //标准id
        typeIds: this.labelCodeList, //类型id
        type: '1'
      }
      saveTag(params).then((res) => {
        console.log(res.data, '标签保存')
        if (res.code == 200) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          setTimeout(() => {
            this.getDocList()
          }, 500)
        } else {
          this.$message({
            message: '保存失败',
            type: 'error'
          })
        }
        this.tagState = false
      })
    },
    // 点击上传拿到当前行uuid
    uploadClick(row) {
      console.log(row, '=======================')
      this.rowId = row.uuid
    },
    // 上传附件
    uploadFn(parma) {
      let that = this
      console.log(parma, that.rowId, '-----------------')
      const formData = new FormData()
      formData.append('multipartFile', parma.file) // 传入bpmn文件
      that.$loading({
        text: '文件上传中'
      })
      uploadFile(formData).then((res) => {
        console.log(res.data, '上传')
        if (res.code == 200) {
          let params = {
            id: that.rowId,
            url: res.data.uploadUrl
          }
          uploadPhoto(params).then((res) => {
            if (res.code == 200) {
              that.$message({
                message: '上传成功',
                type: 'success'
              })
              setTimeout(() => {
                that.getDocList()
              }, 1000)
            } else {
              that.$message({
                type: 'error',
                message: '上传失败!'
              })
            }
          })
        } else {
          that.$message({
            type: 'error',
            message: '上传失败!'
          })
        }
      })
      setTimeout(() => {
        that.$loading().close()
      }, 1500)
    },
    // 删除
    deleteFn(row) {
      console.log(row)
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            // uuid: row.uuid,
            docId: row.id
          }
          deleteDoc(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.refresh = false
              // 在组件移除后，重新渲染组件
              // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
              this.$nextTick(() => {
                this.refresh = true
              })
              // this.getDocList()
              setTimeout(() => {
                this.getDocList()
              }, 1000)
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 模糊查询
    dictSearch() {
      this.page = 1
      this.refresh = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refresh = true
      })
      this.getDocList()
      console.log(this.docLists)
    }
  },
  mounted() {
    this.getDocList()
  }
}
</script>

<style></style>
